import { Flex, VStack } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '~/components/core'
import { Checkbox } from '~/components/shared/Checkbox'
import { MangoButtonVariant } from '~/components/shared/componentStyles/MangoButton.style'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'
import { MangoButton } from '~/components/shared/MangoButton'
import { MangoModal } from '~/components/shared/MangoModal'
import { Size } from '~/types/ThemeTypes'

import { Extension } from '@mangovoice/types'

interface MoveVoicemailModalProps {
  isOpen: boolean
  onClose: () => void
  voicemailBoxes: Extension[]
  currentExtensionId: number
  onMove: (extensionId: number, markAsUnread: boolean) => void
}

export const MoveVoicemailModal = ({
  isOpen,
  onClose,
  voicemailBoxes,
  currentExtensionId,
  onMove,
}: MoveVoicemailModalProps) => {
  const [selectedExtensionId, setSelectedExtensionId] = useState<number>()
  const [markAsUnread, setMarkAsUnread] = useState<boolean>(true)
  const { t } = useTranslation()
  const handleMove = () => {
    if (selectedExtensionId !== undefined) {
      onMove(selectedExtensionId, markAsUnread)
    }
  }
  const filteredVoicemailBoxes = voicemailBoxes.filter(
    (box) =>
      (box.voicemail_enabled === 1 ||
        box.type === 'ExtensionSharedVoicemailBox') &&
      box.id !== currentExtensionId,
  )

  return (
    <MangoModal
      isOpen={isOpen}
      onClose={onClose}
      size={Size.md}
      header={t('voicemail.mangoModal.headerText')}
      footer={
        <>
          <MangoButton
            variant={MangoButtonVariant.Default_100}
            onClick={onClose}
          >
            {t('voicemail.mangoModal.cancelButtonText')}
          </MangoButton>
          <MangoButton
            variant={MangoButtonVariant.Default_300}
            onClick={handleMove}
            ml="0.25rem"
            isDisabled={selectedExtensionId === undefined}
          >
            {t('voicemail.mangoModal.moveButtonText')}
          </MangoButton>
        </>
      }
    >
      <VStack spacing={8} align="stretch" padding="1rem">
        <DropdownSelect
          placeholder={t('voicemail.mangoModal.selectVoicemailBoxText')}
          items={filteredVoicemailBoxes.map((box) => ({
            value: box.id,
            content: box.name,
          }))}
          selectedValue={selectedExtensionId}
          onSelect={(selectedId) =>
            setSelectedExtensionId(selectedId as number)
          }
        />
        <Text>{t('voicemail.mangoModal.destinationBoxWarning')}</Text>
        <Flex justifyContent="flex-start" mt="0.25rem">
          <Checkbox
            defaultChecked={markAsUnread}
            onChange={(value) => setMarkAsUnread(value)}
            label={t('voicemail.mangoModal.markAsUnreadText')}
          />
        </Flex>
      </VStack>
    </MangoModal>
  )
}
